import { render } from "./transaction-pragmatic.vue?vue&type=template&id=9cc7fd52"
import script from "./transaction-pragmatic.vue?vue&type=script&lang=js"
export * from "./transaction-pragmatic.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__